import {proxyClient} from './client'
import {mapQuote, mapQuoteSimple, mapQuotes} from './map'

let ws

export default {
  async get (symbol, options = {simple: true}) {
    const url = buildUrl(symbol, options)
    const res = await proxyClient.get(url)
    const data = res.data
    const map = options.simple ? mapQuoteSimple : mapQuote
    // return data
    return data.map(data => ({
      symbol: data.symbol,
      ...map(data.data)
    }))
  },
  async gets (symbol, options = {simple: true}) {
    const url = buildUrls(symbol, options)
    const res = await proxyClient.get(url)
    const data = res.data
    const map = options.simple ? mapQuote : mapQuotes
    // return data
    return data.map(data => ({
      symbol: data.symbol,
      ...map(data.data)
    }))
  },
  connect (symbol, fn) {
    if (ws) ws.close()
    if (!window.WebSocket) return
    let symbols
    symbols = Array.isArray(symbol) ? symbol.map(symbol => `s_${symbol}`) : [`s_${symbol}`]

    ws = new window.WebSocket(`wss://hq.sinajs.cn/wskt?list=${symbols.join(',')}`)
    ws.onmessage = (event) => {
      const stocks = event.data.split('\n')
        .filter(data => !!data)
        .map(stock => mapQuoteSimple(stock.split('=')[1]))
      fn(stocks)
      ws.send('')
    }
  },

  close () {
    if (ws) ws.close()
  }
}

function buildUrl (symbol, options) {
  if (Array.isArray(symbol)) {
    return '/hq.sinajs.cn/list=' + symbol.reduce((acc, val) => {
      const url = options.simple ? `s_${val}` : val
      return acc + (acc ? `,${url}` : `${url}`)
    }, '')
  } else {
    return '/hq.sinajs.cn/list=' + (options.simple ? `s_${symbol}` : symbol)
  }
}

function buildUrls (symbol, options) {
  if (Array.isArray(symbol)) {
    return '/hq.sinajs.cn/list=' + symbol.reduce((acc, val) => {
      const url = options.simple ? `s_${val}` : val
      return acc + (acc ? `,${url}` : `${url}`)
    }, '')
  } else {
    symbol = symbol.replace(/h/, 'z')
    return '/hq.sinajs.cn/list=' + (options.simple ? `s_${symbol}` : symbol + '_i')
  }
}



// WEBPACK FOOTER //
// ./src/plugins/stock/quotes.js